import VISA_ICON from "../../styles/images/uploads/visa.png";
import AMERICAN_EXPRESS_ICON from "../../styles/images/uploads/amex.png";
import MASTER_CARD_ICON from "../../styles/images/uploads/masterCard.png";
import DISCOVER_ICON from "../../styles/images/uploads/discover.png";
import DINERS_CLUB_ICON from "../../styles/images/uploads/diners.png";
import JCB_ICON from "../../styles/images/uploads/JCB.png";

export const config = () => {
  let APP_ID = "844239";
  let PlanFree = "25";
  let PlanGrowth = "26";
  let PlanEnterprise = "28";
  let SplGrowth = "37";
  let APP_SECRET = "kU9IPc0C65";
  let _auth_token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImtyaXNobmFrdW1hci5zQHZlY3RvbmUuY29tIiwicGFzc3dvcmQiOiJrcmlzaG5hQDg2NiIsImRldmljZUlkIjoiMTU1LWhkbmRuLXdldXdpZWUiLCJzaXBMb2dpbklkIjoiNTM2NCIsInJvbGVJZCI6NCwiZG9tYWluSWQiOjMzMjgsImV4dCI6MjA5LCJjb21wYW55SWQiOjMzNjIsImVuZXRlcHJpc2VpZCI6ODAzMiwiaG9zdEFkZHJlc3MiOiI4MDMyLnVyY2hhdC51bmlmaWVkcmluZy5jby51ayIsIm9yZGVySWQiOjExMDE4LCJkaXJVc2VySWQiOjMyNjI0LCJpYXQiOjE2MjM3NTQ3ODd9.cR2-rh9bxex3riXVPlHW69gNRqZzDR8Tt6ewhuC9eXg";
  // let apiGetAddressApiKey = "CluVSMJ-yUK83VAsuUMNrA748";
  let apiGetAddressApiKey = "LCc0H_klkEGsFjoDI1Rm6g43272";
  let apiGetAddressURL = "https://api.getaddress.io/v2/uk/";
  let API_PRICING_URL = "https://mysqlapi.worktual.co.uk/urpricing-mysql/v1";
  // let BASEPATH="https://stage-mysql-myaccount.worktual.co.uk/";  
  let BASEPATH = "https://myaccount.worktual.co.uk/";
  let apiCcaasHomeCareURL = "https://carehomeapi.audracare.co.uk/homecare_service/v1";
  // let BASEPATH = "http://localhost:3000/";
  let API_SERVICE_URL = "https://mysqlapi.worktual.co.uk/myaccount-mysql/v1";
  let API_SERVICE_URL1 = "https://mysqlapi.worktual.co.uk/urpricing-mysql/v1";
  let CCAAS_SERVICE_URL = "https://ccaasapi.worktual.co.uk/core_service/v1";
  let CCAAS_CONNECTOR_URL = "https://ccaasapi.worktual.co.uk/connector/common/v1";
  // BASEPATH = "https://qa-myaccount.worktual.co.uk/"; 
  // let API_SERVICE_URL = "https://mysqlapi.worktual.co.uk/qamyaccount-mysql/v1";
  //let API_SERVICE_URL = "https://refactor.worktual.co.uk/commonMyaccount-mysql/v1";
  //let API_SERVICE_URL = "http://localhost:5006/MyAccount-mysql/v1";
  let API_SERVICE_SSO_URL = "https://urapi.worktual.co.uk/urauth/v1";
  let API_SERVICE_SSO_V2_URL =
    "https://urapi.worktual.co.uk/urchat/v2";
  let API_SERVICE_REACT_URL =
    "https://urapi.worktual.co.uk/ivr/v1/info";
  let NFS_URL = "https://urapi.worktual.co.uk/urcall/v1/file";
  let SPEECH_URL = "https://urapi.worktual.co.uk/vrengine/v1/";
  let IVR_URL = "https://urapi.worktual.co.uk/ivr/v1";
  let ECOM_PAYMENT_URL = "https://stagepayment.worktual.co.uk/payment/v1/ecommpay";
  let API_SERVICE_URL_UTMS = "https://mysqlapi.worktual.co.uk/urutms-mysql/v1";
  //let API_SERVICE_URL_UTMS = "https://mysqlapi.worktual.co.uk/qaurutms-mysql/v1"; 
  let LOGIN_API =
    "https://mysqlapi.worktual.co.uk/qamyaccount-mysql/v1/login/Urtestcreatejwt";
  let API_SERVICE_ECOMPAY_URL = "https://payment.worktual.co.uk/payment/v1";
  let API_SERVICE_URL_LIVE = "https://mysqlapi.worktual.co.uk/myaccount-mysql/v1";
  let apiReactURL = "https://urapi.worktual.co.uk/ivr/v1/info";
  let apiCRMNodeURL = "https://mysqlapi.worktual.co.uk/urcrm-mysql/v1";
  let didNumPurchaseURL = "https://did.worktual.co.uk";
  let emailService = "https://ccaasapi.worktual.co.uk/emailService/v1"
  let callServices = "https://ccaasapi.worktual.co.uk/callservice/v1";
  let MARKETING_SERVICE = "https://stagemarketingapi.worktual.co.uk/marketing_automation/v1";
  let BOOKING_SERVICE= "https://bookingapi.worktual.co.uk/booking_service/v1";
  let apiNodeURL = "https://mysqlapi.worktual.co.uk/myaccount-mysql/v1";
  let apiCcaasEmailURL= "https://ccaasapi.worktual.co.uk/emailService/v1"; // qa
  let smsServices = "https://ccaasapi.worktual.co.uk/smsService/v1";




  if (process.env.REACT_APP_ENV === "development") {
    //  BASEPATH="https://stage-mysql-myaccount.worktual.co.uk/" 
    apiGetAddressApiKey = "LCc0H_klkEGsFjoDI1Rm6g43272";
    _auth_token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImtyaXNobmFrdW1hci5zQHZlY3RvbmUuY29tIiwicGFzc3dvcmQiOiJrcmlzaG5hQDg2NiIsImRldmljZUlkIjoiMTU1LWhkbmRuLXdldXdpZWUiLCJzaXBMb2dpbklkIjoiNTM2NCIsInJvbGVJZCI6NCwiZG9tYWluSWQiOjMzMjgsImV4dCI6MjA5LCJjb21wYW55SWQiOjMzNjIsImVuZXRlcHJpc2VpZCI6ODAzMiwiaG9zdEFkZHJlc3MiOiI4MDMyLnVyY2hhdC51bmlmaWVkcmluZy5jby51ayIsIm9yZGVySWQiOjExMDE4LCJkaXJVc2VySWQiOjMyNjI0LCJpYXQiOjE2MjM3NTQ3ODd9.cR2-rh9bxex3riXVPlHW69gNRqZzDR8Tt6ewhuC9eXg";
    apiGetAddressURL = "https://api.getaddress.io/v2/uk/";
    //  API_SERVICE_URL = "https://mysqlapi.worktual.co.uk/qamyaccount-mysql/v1";
    //   API_SERVICE_URL = "https://refactor.worktual.co.uk/commonMyaccount-mysql/v1";
    API_SERVICE_URL = "https://mysqlapi.worktual.co.uk/myaccount-mysql/v1";
    API_SERVICE_URL1 = "https://mysqlapi.worktual.co.uk/qamyaccount-mysql/v1";
    BASEPATH = "https://qa-myaccount.worktual.co.uk/"; // Staging site url
    API_SERVICE_URL = "https://mysqlapi.worktual.co.uk/myaccount-mysql/v1";
    API_SERVICE_ECOMPAY_URL = "https://payment.worktual.co.uk/payment/v1";
    API_SERVICE_URL_UTMS = "https://mysqlapi.worktual.co.uk/urutms-mysql/v1";
    CCAAS_SERVICE_URL = "https://qaccaasapi.worktual.co.uk/core_service/v1";
    CCAAS_CONNECTOR_URL = "https://ccaasapi.worktual.co.uk/connector/common/v1";
    //API_SERVICE_URL = "http://localhost:5006/MyAccount-mysql/v1";
    LOGIN_API =
      "https://mysqlapi.worktual.co.uk/qamyaccount-mysql/v1/login/Urtestcreatejwt";
    API_SERVICE_SSO_URL = "https://qaurapi.worktual.co.uk/urauth/v1";
    API_SERVICE_SSO_V2_URL =
      "https://qaurapi.worktual.co.uk/urchat/v2";
    API_SERVICE_REACT_URL =
      "https://qaurapi.worktual.co.uk/ivr/v1/info";
    NFS_URL = "https://qaurapi.worktual.co.uk/urcall/v1/file";
    SPEECH_URL = "https://urapi.worktual.co.uk/vrengine/v1/";
    apiCRMNodeURL = "https://mysqlapi.worktual.co.uk/urcrm-mysql/v1";
    IVR_URL = "https://urapi.worktual.co.uk/ivr/v1";
    ECOM_PAYMENT_URL = "https://payment.worktual.co.uk/payment/v1";
    // ECOM_PAYMENT_URL = "https://payment.worktual.co.uk/payment/v1/ecommpay";
    API_SERVICE_URL_LIVE = "https://mysqlapi.worktual.co.uk/myaccount-mysql/v1";
    didNumPurchaseURL = "https://did.worktual.co.uk";
    apiCcaasHomeCareURL = "https://carehomeapi.audracare.co.uk/homecare_service/v1"
    MARKETING_SERVICE = "https://stagemarketingapi.worktual.co.uk/marketing_automation/v1";
    BOOKING_SERVICE= "https://bookingapi.worktual.co.uk/booking_service/v1";
    apiNodeURL = "https://mysqlapi.worktual.co.uk/myaccount-mysql/v1";
    apiCcaasEmailURL= "https://ccaasapi.worktual.co.uk/emailService/v1";

  } else if (process.env.REACT_APP_ENV === "production") {
    apiGetAddressApiKey = "LCc0H_klkEGsFjoDI1Rm6g43272";
    _auth_token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImtyaXNobmFrdW1hci5zQHZlY3RvbmUuY29tIiwicGFzc3dvcmQiOiJrcmlzaG5hQDg2NiIsImRldmljZUlkIjoiMTU1LWhkbmRuLXdldXdpZWUiLCJzaXBMb2dpbklkIjoiNTM2NCIsInJvbGVJZCI6NCwiZG9tYWluSWQiOjMzMjgsImV4dCI6MjA5LCJjb21wYW55SWQiOjMzNjIsImVuZXRlcHJpc2VpZCI6ODAzMiwiaG9zdEFkZHJlc3MiOiI4MDMyLnVyY2hhdC51bmlmaWVkcmluZy5jby51ayIsIm9yZGVySWQiOjExMDE4LCJkaXJVc2VySWQiOjMyNjI0LCJpYXQiOjE2MjM3NTQ3ODd9.cR2-rh9bxex3riXVPlHW69gNRqZzDR8Tt6ewhuC9eXg";
    apiGetAddressURL = "https://api.getaddress.io/v2/uk/";
    API_PRICING_URL = "https://mysqlapi.worktual.co.uk/urpricing-mysql/v1";
    BASEPATH = "https://myaccount.worktual.co.uk/";// Staging site url
    CCAAS_SERVICE_URL = "https://ccaasapi.worktual.co.uk/core_service/v1";
    API_SERVICE_URL = "https://mysqlapi.worktual.co.uk/myaccount-mysql/v1";
    API_SERVICE_URL1 = "https://mysqlapi.worktual.co.uk/urpricing-mysql/v1";
    API_SERVICE_ECOMPAY_URL = "https://payment.worktual.co.uk/payment/v1";
    API_SERVICE_URL_UTMS = "https://mysqlapi.worktual.co.uk/urutms-mysql/v1";
    CCAAS_CONNECTOR_URL = "https://ccaasapi.worktual.co.uk/connector/common/v1";
    //API_SERVICE_URL_UTMS = "https://mysqlapi.worktual.co.uk/qaurutms-mysql/v1";
    LOGIN_API =
      "https://mysqlapi.worktual.co.uk/qamyaccount-mysql/v1/login/Urtestcreatejwt";
    API_SERVICE_SSO_URL = "https://stagemysql-api.worktual.co.uk/urauth/v1";
    API_SERVICE_SSO_V2_URL =
      "https://qaurapi.worktual.co.uk/urchat/v2";
    apiCRMNodeURL = "https://mysqlapi.worktual.co.uk/urcrm-mysql/v1";
    API_SERVICE_REACT_URL =
      "https://stagemysql-api.worktual.co.uk/ivr/v1/info";
    NFS_URL = "https://stagemysql-api.worktual.co.uk/urcall/v1/file";
    SPEECH_URL = "https://urapi.worktual.co.uk/vrengine/v1/";
    IVR_URL = "https://urapi.worktual.co.uk/ivr/v1";
    ECOM_PAYMENT_URL = "https://payment.worktual.co.uk/payment/v1/ecommpay";
    API_SERVICE_URL_LIVE = "https://mysqlapi.worktual.co.uk/myaccount-mysql/v1";
    didNumPurchaseURL = "https://did.worktual.co.uk";
    apiCcaasHomeCareURL = "https://carehomeapi.audracare.co.uk/homecare_service/v1";
    MARKETING_SERVICE = "https://stagemarketingapi.worktual.co.uk/marketing_automation/v1";
    BOOKING_SERVICE= "https://bookingapi.worktual.co.uk/booking_service/v1";
    apiNodeURL = "https://mysqlapi.worktual.co.uk/myaccount-mysql/v1";
    apiCcaasEmailURL= "https://ccaasapi.worktual.co.uk/emailService/v1";
  }
  let TIMEZONE = "America/New_York";

  return {
    apiCcaasHomeCareURL,
    APP_ID,
    PlanFree,
    PlanGrowth,
    PlanEnterprise,
    SplGrowth,
    APP_SECRET,
    API_SERVICE_URL,
    API_SERVICE_URL1,
    API_SERVICE_URL_UTMS,
    LOGIN_API,
    apiCRMNodeURL,
    TIMEZONE,
    API_SERVICE_SSO_URL,
    API_SERVICE_SSO_V2_URL,
    API_SERVICE_REACT_URL,
    NFS_URL,
    SPEECH_URL,
    IVR_URL,
    ECOM_PAYMENT_URL,
    BASEPATH,
    apiGetAddressApiKey,
    apiGetAddressURL,
    CCAAS_SERVICE_URL,
    API_PRICING_URL,
    API_SERVICE_ECOMPAY_URL,
    _auth_token,
    API_SERVICE_URL_LIVE,
    apiReactURL,
    didNumPurchaseURL,
    emailService,
    callServices,
    CCAAS_CONNECTOR_URL,
    MARKETING_SERVICE,
    BOOKING_SERVICE,apiNodeURL,
    apiCcaasEmailURL,
    smsServices
  };
};


export const OTHERCARDS = [/[1-9]/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/];
export const AMERICANEXPRESS = [/[1-9]/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, /\d/];
export const EXPIRYDATE = [/[0-9]/, /\d/, "/", /\d/, /\d/];
export const CVC = [/[0-9]/, /\d/, /\d/, /\d/];

export const CARDICON = {
  VISA: VISA_ICON,
  MASTERCARD: MASTER_CARD_ICON,
  DISCOVER: DISCOVER_ICON,
  AMERICAN_EXPRESS: AMERICAN_EXPRESS_ICON,
  DINERS_CLUB: DINERS_CLUB_ICON,
  JCB: JCB_ICON
};

export const CARDARR = [
  "VISA",
  "MASTERCARD",
  "AMERICAN_EXPRESS",
  "DISCOVER",
  "DINERS_CLUB",
  "JCB"
];

export const COLORARR = [
  ["#20bdff", "#5433ff"],
  ["#ff4b1f", "#ff9068"],
  ["#ffb347", "#ffcc33"],
  ["#D38312", "#A83279"],
  ["#83a4d4", "#b6fbff"],
  ["#fbd3e9", "#bb377d"]
];

export let API_PAYMENT_CONFIG = {
  sitecode: "UFUK",
  appcode: "UFGBP",
  productcode: "BILL-UR",
  paymentagent: "UFUK",
  servicetype: "RES",
  paymentmode: "DEF",
  site_currency: "GBP",
  payment_country: "United Kingdom,UK",
  euro_currency_code: '&#163;',
  uk_currency_code: '&#163;',
  usa_currency_code: '&#36;',
  euro_currency: 'EUR',
  uk_currency: 'GBP',
  usa_currency: 'USD',
  intl_phone_number_charge: '9.99',
  domestic_phone_number_charge: '2.00',
  userphonecharge: '12.99',
  localnumbercharge: '2.00',
  mobilenumbercharge: '5.00',
  adduseronly_charge: '1.00',
  vatperchantagecharge: '20',
  deliverycharge: '15',
  phonenumbercharge: '2.00',
  product: 'DSK',
  accountid: 'UR-',
  numberShipment: 5.50
};

export const API_VERBS = {
  GET: `GET`,
  POST: `POST`,
  PUT: `PUT`,
  UPDATE: `UPDATE`,
  DELETE: `DELETE`,
  PATCH: `PATCH`,
};

export const whatsappDoc = {
  url: "https://ccaas-storage.worktual.co.uk/chat/7182/ExhibitBClientTerms.pdf"
}


export const industryList = [
    { value: "1", label: "Accounting" },
    { value: "2", label: "Automotive" },
    { value: "3", label: "Banking" },
    { value: "4", label: "Beauty and Cosmetics" },
    { value: "5", label: "Care home" },
    { value: "6", label: "Charities and non-profit organization" },
    { value: "7", label: "Clothing and Footwear" },
    { value: "8", label: "Customer Service" },
    { value: "9", label: "Ecommerce" },
    { value: "10", label: "Education" },
    { value: "11", label: "Electricals" },
    { value: "12", label: "Fintech" },
    { value: "13", label: "Fitness and Wellness" },
    { value: "14", label: "Food and Grocery" },
    { value: "15", label: "Furnitures" },
    { value: "16", label: "Healthcare" },
    { value: "17", label: "Hospitality" },
    { value: "18", label: "HR" },
    { value: "19", label: "Insurance" },
    { value: "20", label: "Legal" },
    { value: "21", label: "Logistics" },
    { value: "22", label: "Manufacturing" },
    { value: "23", label: "Media and Entertainment" },
    { value: "25", label: "Personal Care" },
    { value: "26", label: "Pharma" },
    { value: "27", label: "Real Estate" },
    { value: "28", label: "Recruitment agency" },
    { value: "29", label: "Restaurant" },
    { value: "30", label: "Retail" },
    { value: "31", label: "Technology (Tech startups/SaaS companies)" },
    { value: "32", label: "Telecom" },
    { value: "33", label: "Travel" },
    { value: "24", label: "Others" },

  ];